import styled, { css } from 'styled-components';
import { grey } from '@material-ui/core/colors';

export const PageWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 0;
  align-items: center;

  background-color: black;
  color: white;
  font-size: 0.8em;

  ${(props) => props.scrollable
    && css`
      height: calc(100%);
      overflow: auto;
    `}
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;

  background: ${grey[900]};
  border: 1px solid ${grey[800]};

  height: calc(100vh);
  max-width: 414px; /* ? - please, no specific width */
  overflow: hidden;
  width: 100%;
`;

export const AppBar = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  padding: 0.8rem;
  height: auto;
  width: 100%;
`;

export const Logo = styled.div`
  color: red;

  img {
    width: 100px;
    height: auto;
  }
`;

export const Menu = styled.div`
  font-size: 0.8em;
  font-weight: 800;

  margin-left: auto;
  text-transform: uppercase;

  a {
    color: white;
    text-decoration: none;
  }
`;

export const HeroWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
`;

export const UserWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;

  /* // align-items: center; */
`;

export const AvatarWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
`;

export const UserContentWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;

  margin-top: 0.9rem;
`;

export const NameBlock = styled.div`
  display: flex;
  flex-flow: row nowrap;

  font-size: 1.2em;
  text-transform: uppercase;
`;

export const Name = styled.span`
  display: flex;
  flex-flow: row nowrap;

  margin-right: 0.5rem;

  ${(props) => props.bold
    && css`
      font-weight: 800;
    `}
`;

export const Title = styled.div`
  display: flex;
  flex-flow: row nowrap;
  font-size: 0.9em;
  margin: 0.1rem 0 0.3rem 0;
`;

export const SubTitle = styled.div`
  display: flex;
  flex-flow: row nowrap;

  font-size: 1.2em;
  font-weight: 800;
  text-transform: uppercase;
`;

export const LinkWrapper = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-flow: column nowrap;

  background-color: ${grey[900]};
  overflow: auto;
`;

export const LinkInnerContent = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 0 auto;
  overflow: auto;
`;
